// extracted by mini-css-extract-plugin
module.exports = {"component":"xSAGRqLYGvdxFSfcjqIti","fromPatient":"_1QUJsUJ6TnicuWN8dboQCK"};